import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

const contents = [
  'Phẩm giá và sự tôn trọng',
  'Bạn sẽ được cung cấp dịch vụ chăm sóc y tế chuyên nghiệp và phù hợp mà không phân biệt tuổi tác, giới tính, chủng tộc, tôn giáo, quốc tịch, địa vị xã hội hoặc nếu bạn có bất kỳ nhu cầu',
  'đặc biệt nào. Bạn sẽ được đối xử với lòng trắc ẩn, phẩm giá và sự tôn trọng. Người giám hộ hợp pháp của bạn hoặc bất kỳ người nào được ủy quyền hợp pháp sẽ thực hiện các quyền của',
  'bạn theo mức độ cho phép của pháp luật trong trường hợp bạn không thể làm được điều đó.',
  'Bạn có quyền gặp gỡ và trò chuyện với gia đình, bạn bè và những khách thăm khác trong giờ thăm bệnh trừ khi những quyền này bị hạn chế như một phần của quá trình điều trị y tế ',
  'tổng thể của bạn. Bạn cũng có quyền từ chối khách thăm.',
  'Nhu cầu đặc biệt của bạn sẽ được tôn trọng, cho dù đó là yêu cầu phiên dịch ngôn ngữ, yêu cầu đặc biệt về thực phẩm tôn giáo, thiết bị hoặc trợ giúp tiếp cận trong quá trình chăm sóc\ncủa bạn',
  'Trong thời gian ở tại bệnh viện của chúng tôi, bạn có thể sắp xếp cho việc chăm sóc tinh thần của mình và yêu cầu bất kỳ tư vấn hoặc hỗ trợ mục vụ nào nếu cần.',
  'Bệnh viện của chúng tôi sẽ tôn trọng và tuân thủ các quyết định của bạn được thực hiện theo Chỉ dẫn Y tế Tiên tiến của bạn. Bạn có quyền từ chối hiến mô hoặc tham gia vào bất kỳ loại\nnghiên cứu y tế nào trong thời gian nằm viện tại bệnh viện của chúng tôi.',
  'Chỉ dẫn Y tế Tiên tiến (AMD) là một tài liệu pháp lý mà bạn ký trước để thông báo cho bác sĩ rằng bạn không muốn sử dụng bất kỳ biện pháp điều trị duy trì sự sống nào nhằm kéo dài sự\nsống của bạn trong trường hợp bạn trở nên bệnh nặng không thể chữa khỏi và mất ý thức, dẫn đến nguy cơ tử vong',
];

const contents2 = [
  'Bảo mật và Riêng tư',
  'Thông tin y tế của bạn và tất cả các khía cạnh của việc chăm sóc bạn đều được giữ bí mật và riêng tư. Hồ sơ y tế của bạn chỉ được truy cập bởi những người tham gia điều trị và sắp xếp\nchăm sóc cho bạn. Những hồ sơ này sẽ không được tiết lộ cho bất kỳ ai mà không có sự đồng ý của bạn, trừ khi pháp luật yêu cầu hoặc theo hợp đồng với bên thứ ba trả tiền',
  'Bạn có thể yêu cầu một bản sao báo cáo y tế của mình theo chính sách của bệnh viện. Hồ sơ y tế của bạn được giữ trong một môi trường an toàn và được bảo vệ.',
];

const contents3 = [
  'Nhận Thông tin và Giải thích về Điều trị của Bạn',
  'Bạn có quyền nhận thông tin về tình trạng y tế của mình, điều trị và các kết quả có thể xảy ra bằng ngôn ngữ mà bạn hiểu (nếu có thể). Điều này bao gồm thông tin về các rủi ro có thể,\ntác dụng phụ và các phương pháp điều trị thay thế.',
  'Bạn có quyền biết tên của các chuyên gia y tế chịu trách nhiệm điều trị và chăm sóc cho bạn.',
  'Thông tin được cung cấp sẽ giúp bạn tham gia vào các quyết định liên quan đến tình trạng y tế của bạn và phương pháp điều trị tiềm năng.',
  'Bất cứ lúc nào, bạn cũng sẽ được tiếp cận với những người và thông tin về giáo dục sức khỏe, tự chăm sóc và phòng ngừa bệnh tật.',
  'Bạn có quyền từ chối chăm sóc y tế hoặc điều trị được khuyến nghị trong phạm vi cho phép của pháp luật. Tuy nhiên, nếu bạn chọn không điều trị hoặc rời bệnh viện trái với lời khuyên\ncủa bác sĩ, bạn sẽ phải chịu trách nhiệm về bất kỳ hậu quả y tế nào do quyết định của bạn. Bạn sẽ được thông báo về các hậu quả y tế có thể xảy ra.',
];

const contents4 = [
  'Tư vấn Tài chính và Ước tính Hóa đơn',
  'Bạn có quyền được tư vấn tài chính và nhận ước tính hóa đơn bệnh viện vào thời điểm nhập viện. Hãy lưu ý yêu cầu thông tin liên quan đến bất kỳ thay đổi nào trong kế hoạch điều trị\nhoặc nhu cầu y tế có thể thay đổi ước tính ban đầu này.',
  'Bạn có quyền yêu cầu thông tin này và tìm kiếm sự giải thích cần thiết trong thời gian nằm viện tại Bệnh viện của chúng tôi.',
];

const contents5 = [
  'Khi Bạn Xuất Viện',
  'Hãy yêu cầu hướng dẫn chăm sóc sức khỏe bằng văn bản trong trường hợp cần thiết; chúng tôi muốn bạn cảm thấy rằng bạn có đủ thông tin cần thiết để tự chăm sóc tại nhà. Hãy đảm\nbảo rằng bạn và người chăm sóc của bạn hiểu rõ những hướng dẫn này và đừng ngần ngại hỏi chúng tôi đến khi bạn nắm rõ những thông tin cần thiết.',
  'Thuốc của bạn phải được sử dụng theo đơn thuốc đã kê, và nếu bạn có bất kỳ lo ngại nào về sự an toàn của mình, hãy thông báo cho y tá, bác sĩ hoặc người điều trị của bạn.',
  'Hãy đảm bảo rằng bạn có tên và thông tin liên hệ của các bác sĩ, phòng khám, nhà thuốc và dịch vụ phục hồi chức năng để dễ dàng tham khảo.',
];

const PatientsRights = () => {
  return (
    <>
      <SectionTitle title="Quyền của bệnh nhân" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  marginBottom: '10px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === 3 || i === 5 || i === 6 || i === 7 || i === 8) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                  marginBottom: '20px',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents2.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents2.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents3.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents3.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents4.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents4.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '48px auto 24px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents5.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '500',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          if (i === contents5.length - 1) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '15px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '15px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              {v}
              <p />
            </Typography>
          );
        })}
      </Box>
    </>
  );
};

export default PatientsRights;
